import { SUPPORT_WHATSAPP, WHATS_NEW_RULES, WhatsNewItem, WhatsNewState } from './whats-new.config';

// Início do dia (hora local do navegador) de uma data AAAA-MM-DD.
const startOfDay = (date: string) => new Date(`${date}T00:00:00`);

const sameLocalDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

// Link do WhatsApp do suporte com a mensagem pronta.
export function supportWhatsAppUrl(
  subject: string,
  companyName: string | null,
  phone = SUPPORT_WHATSAPP,
): string {
  const message = companyName ? `Olá. Quero ${subject} na empresa ${companyName}.` : `Olá. Quero ${subject}.`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}

// Novidades a mostrar agora: só as lançadas depois do primeiro acesso, ainda dentro da validade,
// não vistas e permitidas ao usuário. Mais novas primeiro, limitadas pelo teto do dia (as vistas
// hoje, em qualquer aparelho, já contam).
export function pendingWhatsNew(
  items: readonly WhatsNewItem[],
  state: WhatsNewState,
  now: Date,
  opts: { hasRole: (role: string) => boolean; supportAvailable: boolean },
): WhatsNewItem[] {
  const firstAccess = new Date(state.firstAccessAt);
  const seenIds = new Set(state.seen.map((s) => s.id));

  const candidates = items.filter((item) => {
    const start = startOfDay(item.date);
    if (!(start > firstAccess)) return false;
    const expiresAt = new Date(start);
    expiresAt.setDate(expiresAt.getDate() + WHATS_NEW_RULES.validityDays);
    if (!(now < expiresAt)) return false;
    if (seenIds.has(item.id)) return false;
    if (item.role && !opts.hasRole(item.role)) return false;
    if (item.action.type === 'support' && !opts.supportAvailable) return false;
    return true;
  });

  // Ordenação estável: empate de data mantém a ordem da lista.
  const sorted = candidates
    .map((item, index) => ({ item, index }))
    .sort((a, b) => (a.item.date < b.item.date ? 1 : a.item.date > b.item.date ? -1 : a.index - b.index))
    .map((entry) => entry.item);

  const seenToday = state.seen.filter((s) => sameLocalDay(new Date(s.seenAt), now)).length;
  return sorted.slice(0, Math.max(0, WHATS_NEW_RULES.maxPerDay - seenToday));
}
